import React, { useState, useEffect } from 'react';
import { animate, motion } from "framer-motion"
import '../styles/client.css';
import { getDatabase, ref, set, push, get } from "firebase/database";

import exit from "../asstes/dashboard/add.png"


import exittab from "../asstes/dashboard/no.png"



const ClientSpace = ({clientId , anime}) => {

      const payment_methods = ["Hand-To-Hand" , "Bill" , "Check" , "Bank Transfer"];
      const vehicle_types = [
        "Remorque plateau Avec Ridelles - Tracteur 4x2",
        "Remorque plateau Avec Ridelles - Tracteur 6x4",
        "Remorque plateau Avec Ridelles - Tracteur 6x6",
        "Remorque plateau Sans Ridelles - Tracteur 4x2",
        "Remorque plateau Sans Ridelles - Tracteur 6x4",
        "Remorque plateau Sans Ridelles - Tracteur 6x6",
        "Porte-Engins - Tracteur 4x2",
        "Porte-Engins - Tracteur 6x4",
        "Porte-Engins - Tracteur 6x6",
        "Porte-Engins Syrbaissé - Tracteur 4x2",
        "Porte-Engins Syrbaissé - Tracteur 6x4",
        "Porte-Engins Syrbaissé - Tracteur 6x6",
        "Remorque Large - Tracteur 4x2",
        "Remorque Large - Tracteur 6x4",
        "Remorque Large - Tracteur 6x6",
        "Porte-Véhicules - Remorque citrene",
        "Porte-Véhicules - Tracteur 4x2",
        "Porte-Véhicules - Tracteur 6x4",
        "Porte-Véhicules - Tracteur 6x6",

        "Remorque citrene - Tracteur 4x2",
        "Remorque citrene - Tracteur 6x4",
        "Remorque citrene - Tracteur 6x6",


        "Forgon 2 Panneaux" ,  
        "Forgon 3 Panneaux"
      ];

  const [emptyForm , setEmptyForm] = useState(false);

  const [showConf , setShowConf] = useState(false);
  
  const [activeTab, setActiveTab] = useState('order1');
  const [formData, setFormData] = useState({
    order1 :{nom:"" , Telephone :"" , lieu_de_chargement: "" , lieu_de_décharge :"" , taille_expédition:"" ,poids_expédition :"" ,type_de_véhicule:vehicle_types[0] , méthode_de_paiement:payment_methods[0] , unités:"false" , nombre_unités:""  ,description_des_unités : "", descriptions_expédition :""  ,  submited : false },
  });

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [activeTab]: {
        ...prevData[activeTab],
        [name]: value,
      },
    }));
  };

  const pushOrder = ()=> {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    today = dd + '/' + mm + '/' + yyyy;

    const db = getDatabase();
    push(ref(db, 'Shipment'), {
        client_id: clientId,
        name: formData[activeTab]["nom"],
        phone: formData[activeTab]["Telephone"],
        charging_location: formData[activeTab]["lieu_de_chargement"],
        discharging_location: formData[activeTab]["lieu_de_décharge"],
        size: formData[activeTab]["taille_expédition"],
        weight: formData[activeTab]["poids_expédition"],
        price:0,
        vehicle_type: formData[activeTab]["type_de_véhicule"],
        payment_method: formData[activeTab]["méthode_de_paiement"],
        palette: formData[activeTab]["unités"],
        palette_number: formData[activeTab]["nombre_unités"],
        description: formData[activeTab]["descriptions_expédition"],
        units_description : formData[activeTab]["description_des_unités"], 
        time_requested: today,
        state: "w"
    });


    setFormData((prevData) => ({
      ...prevData,
      [activeTab]: {
        ...prevData[activeTab],
        ["submited"]: true,
      },
    }));


    console.log("Shipment Added: [" + formData[activeTab]["name"] + " " +formData[activeTab]["description"] + "]");

  }

  const handleSubmit = (e) => {
e.preventDefault();
    if(!formData[activeTab]["submited"]){

      if(formData[activeTab]["name"] != "" && formData[activeTab]["phone"] != "" && formData[activeTab]["charging_location"] != "" && formData[activeTab]["discharging_location"] != "" && formData[activeTab]["taille_expédition"] != "" && formData[activeTab]["poids _expédition"] != "" && formData[activeTab]["name"] != "" && formData[activeTab]["name"] != ""){
        
        
setShowConf(true)

    
      }else{
        setEmptyForm(true)
        setTimeout(()=> {
          setEmptyForm(false)
        },3000
        )
      }

    
  }
  };

  const addTab = () => {
    const newTab = `order${Object.keys(formData).length + 1}`;
    setFormData((prevData) => ({
      ...prevData,
      [newTab]: {nom:"" , Telephone :"" , lieu_de_chargement: "" , lieu_de_décharge :"" , taille_expédition:"" ,poids_expédition :"" ,type_de_véhicule:vehicle_types[0] , méthode_de_paiement:payment_methods[0] , unités:"false" , nombre_unités:""  ,description_des_unités : "", descriptions_expédition :""  ,  submited : false },
    }));
    setActiveTab(newTab);
  };

  const deleteTab = (tab , index) => {


    
    const formDataTest = Object.keys(formData);
    if(formDataTest.length != 1){
      const { [tab]: deletedTab, ...restTabs } = formData;
      setFormData(restTabs);
      // If the deleted tab was active, switch to another tab
      if (activeTab === tab) {
        const remainingTabs = Object.keys(restTabs);
        if (remainingTabs.length > 0) {
          setActiveTab(remainingTabs[remainingTabs.length -1]);
        }
      
    }
    }
    
  };


  const insertOrder =()=> {
    

    
  }

  return (
    <motion.div className='left-orders orderTabPage'
      initial={{zIndex:2}}
      animate={anime ? { opacity: 1 , zIndex:2} : { opacity: 0 ,zIndex:1 }}
    >

        <div className="dash-page-title">
          <p>Korsaa</p>
          <p>Commander Maintenant</p>
        </div>
      <div className='order-tabs flex align-center'> 
        {Object.keys(formData).map((tab ,index) => (


          <motion.div key={tab} 
          className="order-tab white-back bold flex align-center justify-center"
          initial={{backgroundColor:"white" , color:"#362FD9"}}
          animate={activeTab == tab ? {backgroundColor:"#362FD9" , color:"white"} :{backgroundColor:"white" , color:"#362FD9"}}
          >

            <p onClick={() => handleTabChange(tab)}>{tab}</p>
            

            <img src={exittab} onClick={()=> deleteTab(tab , index)}/>
          </motion.div>
          
          
        ))}
        <div onClick={addTab} className='add-order-tab '>
            
        <img src={exit}/>

        </div>
      </div>
      <form onSubmit={handleSubmit} className='tabForm'>
        
      <p className='absolute tabform-main-text'>Créez votre commande maintenant</p>
        {Object.keys(formData[activeTab]).map((fieldName) => (
          <div key={fieldName} className='input-container'>
            {
              fieldName === "submited" ? null :
            
            <label htmlFor={fieldName}>{fieldName.replace("_" , " ").replace("_" , " ")}:</label>
            }



            {
          fieldName === "type_de_véhicule" ?
          (
              <select
                id={fieldName}
                name={fieldName}
                value={formData[activeTab][fieldName]}
                onChange={handleInputChange}
              >
                
                {vehicle_types.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}

              </select>
          )
          :
          fieldName === "méthode_de_paiement" ? 
          (
            <select
                id={fieldName}
                name={fieldName}
                value={formData[activeTab][fieldName]}
                onChange={handleInputChange}
              >
                
                {payment_methods.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}

              </select>

          )
          :
          fieldName === "unités" ?
                (
                    <div className='radios-container'>
                <label>
                  <input
                    type="radio"
                    id={`${fieldName}-true`}
                    name={fieldName}
                    value="true"
                    checked={formData[activeTab][fieldName] === 'true'}
                    onChange={handleInputChange}
                  />
                  Oui
                </label>
                <label>
                  <input
                    type="radio"
                    id={`${fieldName}-false`}
                    name={fieldName}
                    value="false"
                    checked={formData[activeTab][fieldName] === 'false'}
                    onChange={handleInputChange}
                  />
                  Non
                </label>
              </div>
                  )
          :

          fieldName === "nombre_unités" ?
          (

            <div>

            <input
              type="number"
              id={fieldName}
              name={fieldName}
              className='palette_input'
              placeholder={"Nombre d'unités"}
              value={formData[activeTab][fieldName]}
              disabled={formData[activeTab]["unités"] === "false"}
              onChange={handleInputChange}
            />


            
          </div>
          ):

          fieldName === "description_des_unités" ?
          (

            <input
              type="text"
              id={fieldName}
              name={fieldName}
              placeholder={'Entrez la ' + fieldName.replace("_" , " ").replace("_" , " ")}
              value={formData[activeTab][fieldName]}
              
              disabled={formData[activeTab]["unités"] === "false"}
              onChange={handleInputChange}
            />
          ):
          fieldName !== "submited" ?

          (
            <input
              type="text"
              id={fieldName}
              name={fieldName}
              placeholder={'Entrez Votre ' + fieldName.replace("_" , " ").replace("_" , " ") + ' ici'}
              value={formData[activeTab][fieldName]}
              onChange={handleInputChange}
            />
          ):
          null
        }
          </div>

            
        ))}
        <button className={ !formData[activeTab]["submited"] ? "btn orange-back bold" : "  btn disabled"} type="submit"  disabled={formData[activeTab]["submited"]}>Envoyer</button>
        
        <motion.p className="hidden-text" initial={{opacity:0 , color:"black"}} animate={emptyForm ? {opacity : 1} : {opacity : 0}}>Please Fill All the fields</motion.p>
      
      
      </form>

      
      <motion.div className='order-conf-overlay flex justify-center align-center'
                initial={{display:"none"}}
                animate={showConf ? {display : "flex" , opacity : 1 , scale :1} : {display : "none" , opacity : 0 , scale :0.5}}
            >

            <motion.div className='order-conf-overlay-content white-back flex flex-column justify-center align-center'
                initial={{display:"none"}}
                animate={showConf ? {display : "flex" , opacity : 1 , scale :1} : {display : "none" , opacity : 0 , scale :0.5}}
            >

              <p className='black-text'>Please Confirm Your order</p>
              
              <div className="logout-actions flex bold align-center justify-center margin-top20">
                        <div className="btn flex orange-back align-center justify-center"
                        onClick={()=> {
                          pushOrder();
                          setShowConf(false)
                        }}
                        
                        >Yes</div>
                        <div className="btn flex  align-center justify-center cancel-action"
                            onClick={() => {
                              setShowConf(false)
                            }}
                        >Cancel</div>
                    </div>

            </motion.div>


            </motion.div>

    </motion.div>
  );
};

export default ClientSpace;
